import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Kalkulator", -1)
const _hoisted_3 = { class: "settings" }
const _hoisted_4 = { class: "calculator" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Twoje wynagrodzenie", -1)
const _hoisted_6 = { class: "calculator__section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Brutto", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", null, "Netto", -1)
const _hoisted_9 = { class: "calculator__section" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Składniki wynagrodzenia", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Dni w pracy", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Podstawa", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Wynagrodzenie za godziny nocne", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Premie", -1)
const _hoisted_15 = { class: "calculator__section" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h3", null, "Nadgodziny 100%", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h3", null, "Nadgodziny 50%", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", null, "Podatki zdrowotne", -1)
const _hoisted_19 = { class: "calculator__section" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h3", null, "Ubezpieczenie emerytalne (9,76%)", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h3", null, "Ubezpieczenie rentowe (1,5%)", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", null, "Ubezpieczenie chorobowe (2,45%)", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", null, "Ubezpieczenie zdrowotne (9%)", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h2", null, "Podatki PIT", -1)
const _hoisted_25 = { class: "calculator__section" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", null, "Zaliczka na podatek", -1)

import BaseNotecard from "@/components/UI/BaseNotecard.vue";
import TopBar from "@/components/TopBar.vue";
import BaseButton from "@/components/UI/BaseButton.vue";
import { useCalculatorStore } from "@/store/calculator";
import { useUserInfo } from "@/store/userInfo";
import { computed, onBeforeMount, ref, toRefs } from "vue";
import MonthDialog from "@/components/UI/DialogViews/MonthDialog.vue";
import { Presence } from "@/types/dailyInfo";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalculatorView',
  setup(__props) {

const calculatorStore = useCalculatorStore();
const currency = useUserInfo().userInfo.currency.value;

const daysAtWork = ref(0);
const year = toRefs(calculatorStore).year;
const month = toRefs(calculatorStore).month;

const monthDialog = ref(false);

const checkedMonth = computed(() => {
  const months = [
    "",
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ];
  return `${months[month.value]} ${year.value}`;
});

const openMonthDialog = () => {
  monthDialog.value = true;
};

const closeMonthDialog = () => {
  monthDialog.value = false;
};

const calc = async () => {
  daysAtWork.value = await calculatorStore.getDaysAtWork(
    year.value,
    month.value,
    Presence.atwork
  );
  calculatorStore.getNightAllowance(year.value, month.value);
  calculatorStore.getBaseBrutto(year.value, month.value);
  calculatorStore.getOverhoursPayment(year.value, month.value); // do dodania obliczanie godzin w miesiącu, nie dni...
};

onBeforeMount(() => {
  calc();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TopBar, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(BaseNotecard, null, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("h1", {
            class: "setting__date",
            onClick: openMonthDialog
          }, _toDisplayString(_unref(checkedMonth)), 1),
          (monthDialog.value)
            ? (_openBlock(), _createBlock(MonthDialog, {
                key: 0,
                onClose: closeMonthDialog,
                title: "Wybór miesiąca",
                calculator: ""
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(BaseButton, { onClick: calc }, {
          default: _withCtx(() => [
            _createTextVNode("Sprawdź")
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("section", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).brutto) + " " + _toDisplayString(_unref(currency)), 1),
        _hoisted_8,
        _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).nettoPayment), 1)
      ]),
      _createElementVNode("section", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("article", null, [
          _hoisted_11,
          _createElementVNode("p", null, _toDisplayString(daysAtWork.value), 1),
          _hoisted_12,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).baseBrutto) + " " + _toDisplayString(_unref(currency)), 1),
          _hoisted_13,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).nightAllowance), 1)
        ]),
        _hoisted_14,
        _createElementVNode("section", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).overhoursWage.hundert), 1),
          _hoisted_17,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).overhoursWage.fifty), 1)
        ]),
        _hoisted_18,
        _createElementVNode("section", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).pensionInsurance) + " " + _toDisplayString(_unref(currency)), 1),
          _hoisted_21,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).disabilityInsurance) + " " + _toDisplayString(_unref(currency)), 1),
          _hoisted_22,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).sickInsurance) + " " + _toDisplayString(_unref(currency)), 1),
          _hoisted_23,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).healthInsurance) + " " + _toDisplayString(_unref(currency)), 1)
        ]),
        _hoisted_24,
        _createElementVNode("section", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("p", null, _toDisplayString(_unref(calculatorStore).incomeTax), 1)
        ])
      ])
    ])
  ]))
}
}

})